// extracted by mini-css-extract-plugin
var _1 = "qmHjU9";
var _2 = "kScYcc";
var _3 = "oKZJc1";
var _4 = "okPj8k";
var _5 = "m4LBO3";
var _6 = "UmalHr";
var _7 = "CbDqAl";
var _8 = "HAqaU1";
export { _1 as "ease-transition", _2 as "gradient-titanic-80", _3 as "linear-transition-05", _4 as "shadow-medium-titanic", _5 as "shadow-medium-titanic-hover", _6 as "shadow-titanic-1", _7 as "shadow-white", _8 as "text" }
